"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var Parameters = (function () {
    function Parameters() {
        this._params = [];
    }
    Parameters.prototype.clone = function () {
        var params = new Parameters();
        for (var key in this._params) {
            if (this._params.hasOwnProperty(key)) {
                var value = this._params[key];
                params.setParam(key, _.cloneDeep(value));
            }
        }
        return params;
    };
    Parameters.prototype.setParam = function (name, value) {
        this._params[name] = value;
    };
    Parameters.prototype.getParamString = function (name) {
        return "" + this._params[name];
    };
    Parameters.prototype.getParamBoolean = function (name) {
        var value = this._params[name];
        if (typeof (value) === "boolean") {
            return value;
        }
        else if (typeof (value) === "string") {
            return (value.toLowerCase() !== "false");
        }
        else if (typeof (value) === "number") {
            return value !== 0;
        }
        else {
            return !!this._params[name];
        }
    };
    Parameters.prototype.getParamNumber = function (name) {
        var value = this._params[name];
        if (value === null || value === undefined) {
            return 0;
        }
        return parseFloat(this._params[name]);
    };
    Parameters.prototype.getParamObject = function (name) {
        return this._params[name];
    };
    Parameters.prototype.maximumOneOffContribution = function () {
        var enforcedThreshold = Math.floor(this.nonConcessionalContributionThreshold() / 10000) * 10000;
        return 3 * enforcedThreshold;
    };
    Parameters.prototype.nonConcessionalContributionThreshold = function () {
        return this.getParamNumber("NonConcessionalContributionThreshold");
    };
    Parameters.prototype.concessionalContributionThreshold = function () {
        return this.getParamNumber("ConcessionalContributionThreshold");
    };
    Parameters.prototype.remainingConcessionalContribution = function () {
        var enforcedThreshold = Math.floor(this.concessionalContributionThreshold() / 2500) * 2500;
        var superannuationSalary = this.getParamNumber("Salary");
        if (this.getParamBoolean('EnforceMaximumContributionBase')) {
            superannuationSalary = Math.min(this.getParamNumber("Salary"), this.getParamNumber("SGCMaximumContributionBase") * 4);
        }
        return enforcedThreshold - (superannuationSalary * this.getParamNumber("EmployerContributionRate"));
    };
    Parameters.prototype.remainingConcessionalContribution_2 = function () {
        var enforcedThreshold = Math.floor(this.concessionalContributionThreshold() / 2500) * 2500;
        var superannuationSalary = this.getParamNumber("Salary_2");
        if (this.getParamBoolean('EnforceMaximumContributionBase')) {
            superannuationSalary = Math.min(this.getParamNumber("Salary_2"), this.getParamNumber("SGCMaximumContributionBase") * 4);
        }
        return enforcedThreshold - (superannuationSalary * this.getParamNumber("EmployerContributionRate_2"));
    };
    Parameters.prototype.equipInitialPremium = function (alwaysCalculate) {
        if (alwaysCalculate === void 0) { alwaysCalculate = false; }
        var age;
        var salary;
        var defaultPremium;
        var userSpecifiedPremium;
        var equipDeathPremiums;
        var equipTPDPremiums;
        var equipDeathCoverTaper;
        var equipTPDCoverTaper;
        equipDeathPremiums = this.getParamObject("EquipDeathPremiums");
        equipTPDPremiums = this.getParamObject("EquipTPDPremiums");
        equipDeathCoverTaper = this.getParamObject("EquipDeathCoverTaper");
        equipTPDCoverTaper = this.getParamObject("EquipTPDCoverTaper");
        age = this.getParamNumber("AgeNow") + 1;
        salary = this.getParamNumber("Salary");
        userSpecifiedPremium = this.getParamNumber("EquipInsurancePremium");
        defaultPremium = salary * 4 / 1000 * equipDeathPremiums.cost(age) * equipDeathCoverTaper.cost(age) +
            salary * 4 / 1000 * equipTPDPremiums.cost(age) * equipTPDCoverTaper.cost(age);
        if (alwaysCalculate || userSpecifiedPremium === -1) {
            return defaultPremium;
        }
        return userSpecifiedPremium;
    };
    return Parameters;
}());
exports.Parameters = Parameters;
//# sourceMappingURL=Parameters.js.map